import { HttpService } from "../http";

export class HistoryService extends HttpService {
  async fetchHistory(payload: Record<string, any>): Promise<any> {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/organization-membership/${payload.id}/history`;

    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      console.error("Failed to fetch history:", error);
      throw error;
    }
  }
}
